import { render, staticRenderFns } from "./CriarEtapa.vue?vue&type=template&id=3e59bbc2&scoped=true&"
import script from "./CriarEtapa.vue?vue&type=script&lang=js&"
export * from "./CriarEtapa.vue?vue&type=script&lang=js&"
import style0 from "./CriarEtapa.vue?vue&type=style&index=0&id=3e59bbc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e59bbc2",
  null
  
)

export default component.exports